import "./styles.css";
import Caraga from "../../assets/caraga.jpg";
import Ciscon from "../../assets/ciscon.jpg";
import Grad from "../../assets/gradpic.jpg";
import Ict from "../../assets/ict.jpg";
import Rdp from "../../assets/cisconcert.jpg";
import ScrapCycle from "../../assets/ScrapButuan.png";
import ScrollAnimation from "react-animate-on-scroll";

export function Gallery() {
  return (
    <div className="container">
      <div className="wrapper">
        <ScrollAnimation animateIn="fadeInUp">
          <h1 className="section-header">Gallery</h1>
        </ScrollAnimation>
        <div className="main-content">
          <div className="box">
            <img src={Grad} alt="" />
            <div className="img-text">
              <div className="content">
                <p>
                  This is my graduation photo. My academic journey in CSU shaped
                  my enthusiasm for the ever-evolving world of technology.
                </p>
              </div>
            </div>
          </div>
          <div className="box">
            <img src={Rdp} alt="" />
            <div className="img-text">
              <div className="content">
                <p>
                  We received this certificate in recognition of our Best Paper
                  Award-winning thesis at the 2nd International Conference on
                  Computing and Information Sciences.
                </p>
              </div>
            </div>
          </div>
          <div className="box">
            <img src={Ciscon} alt="" />
            <div className="img-text">
              <div className="content">
                <p>
                  Our thesis has been honored with the esteemed title of "Best
                  Paper" at the 2nd International Conference on Computing and
                  Information Sciences.
                </p>
              </div>
            </div>
          </div>

          <div className="box">
            <img src={Caraga} alt="" />
            <div className="img-text">
              <div className="content">
                <p>
                  Together with my teammates in ScrapCycle and our mentor in Navigatu, we won the
                  DICT-Caraga’s Philippine Startup Challenge 7.
                </p>
              </div>
            </div>
          </div>

          <div className="box">
            <img src={ScrapCycle} alt="" />
            <div className="img-text">
              <div className="content">
                <p>
                  The Scrapcycle mobile app streamlines recycling for Butuanons,
                  letting them conveniently trade recyclables into cash from the
                  comfort of their homes.
                </p>
              </div>
            </div>
          </div>

          <div className="box">
            <img src={Ict} alt="" />
            <div className="img-text">
              <div className="content">
                <p>
                  Using C programming language, I passed the ICT Proficiency
                  Diagnostic Examination of DICT.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
